<template>
  <div class="body">
    <div class="bodySelect">
      <div class="bodySelect_flex">
        <!-- <div class="select">
          <div
            style="
              display: flex;
              font-size: 0.14rem;
              padding: 0.16rem;
              cursor: pointer;
            "
          >
            <div>需求</div>
            <div class="select_icon select_icon_"></div>
          </div>
          <div class="select_box_">
            <div class="select_box">
              <div class="select_box_slect">需求</div>
            </div>
          </div>
        </div> -->
        <!-- 类型、等进行 -->
        <input placeholder="输入需求名称搜索" v-model="from1.keyWord" @keydown="onmousedown" />
      </div>
      <button @click="
        from1.pageIndex = 1;
      getList();
      ">
        <img src="../../assets/yxsc_ss.png" />
        搜索
      </button>
    </div>
    <!-- 选择 -->
    <div class="selectList" style="margin-bottom: 0.3rem; margin-top: 0.2rem">
      <!--   {
                  name: '全部',
                  value: '0',
                },     {
                  name: '待签单',
                  value: '2',
                },
                {
                  name: '已签单',
                  value: '3',
                },-->
      <dropDown @tabClick="tabback" :boxRef="{
        left: [
          {
            name: '需求状态',
            value: '1',
            listShow: true,
            list: [
              {
                name: '招募中',
                value: '1',
              },

              {
                name: '已合作',
                value: '4',
              },
              {
                name: '已完成',
                value: '7',
              },
            ],
          },
          // {
          //   name: '技能类型',
          //   value: '2',
          //   listShow: true,
          //   list: [
          //     {
          //       name: '技能类型',
          //       value: '2-1',
          //     },
          //   ],
          // },
        ],
        center: [
          {
            name: '预算价格',
            value: '2',
            listShow: true,
            width: '2.8rem',
            list: [
              {
                name: '全部',
                value: '0',
              },
              {
                name: '0-100元',
                value: '1',
              },
              {
                name: '100-1000元',
                value: '2',
              },
              {
                name: '1000-10000元',
                value: '3',
              },
              {
                name: '大于10000元',
                value: '4',
              },
            ],
          },
          // {
          //   name: '发布时间',
          //   value: '6',
          //   listShow: true,
          //   list: [
          //     {
          //       name: '时长',
          //       value: '6-1',
          //     },
          //   ],
          // },
        ],
      }"></dropDown>
    </div>
    <!-- 列表 -->
    <moduleNewNeed @click="goParticulars(index)" v-for="index in list" :key="index" :item="index"></moduleNewNeed>
    <el-pagination v-model:current-page="from1.pageIndex" v-model:page-size="from1.pageSize" @size-change="sizeChange"
      @current-change="currentChange" style="margin: 0.4rem 0" background layout="prev, pager, next"
      :total="from1.total" />
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import moduleNewNeed from "../../components/moduleNewNeed.vue";
import dropDown from "../../components/comTemplate/drop-down.vue";
import { Axios } from "@/assets/js/ls_com_axios.js";

// import {
// 	useRouter
// } from "vue-router";
const from = ref({
  region: 0,
});
const from1 = ref({
  keyWord: "",
  pageIndex: 1,
  pageSize: 7,
  total: 0,
  condition: {},
});
const list = ref([]);
const router = useRouter();
const region = 0;
let inputTitle = router.currentRoute.value.query.inputTitle;
from1.value.keyWord = inputTitle || "";
/* 跳转详情页 */
const goParticulars = function (item) {
  router.push({
    path: "/ShadowBusinessParticulars",
    query: {
      id: item.id,
    },
  });
};
const onmousedown = () => {
  if (event.keyCode == 13) {
    from1.value.pageIndex = 1;
    getList();
  }
};
const tabback = (...val) => {
  console.log("valvalval", val);
  if (val[0] == 1) {
    if (val[1] == "0") {
      delete from1.value.condition.state;
    } else if (val[1] > 0) {
      from1.value.condition.state = val[1];
    }
  } else if (val[0] == 2) {
    if (val[1].name == "预算价格") {
      delete from1.value.condition.minPriceRange;
      delete from1.value.condition.maxPriceRange;
      // getList();
      return; // 返回之前避免进入后续逻辑
    }
    if (val[3].name == "大于10000元") {
      from1.value.condition.minPriceRange = 10000;
      delete from1.value.condition.maxPriceRange;
    } else if (val[3].name == "全部") {
      delete from1.value.condition.minPriceRange;
      delete from1.value.condition.maxPriceRange;
    } else {
      let arr = val[3].name.match(/\d+/g);
      from1.value.condition.minPriceRange = arr[0];
      from1.value.condition.maxPriceRange = arr[1];
    }
  }
  // 在条件判断之后执行getList()
  getList();
};
const getList = function () {
  !from1.value.condition.state ? (from1.value.condition.state = 1) : "";
  from1.value.condition = {
    isHomePage: 2,
    ...from1.value.condition,
  };
  let obj = { ...from1.value };

  for (let key in obj) {
    if (obj[key] === "" || obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
  }
  obj.condition.type = 1;
  Axios("POST", "/material/material/need/list", obj, false, function (res) {
    if (res.data.code == 200) {
      console.log(res.data.total);
      from1.value.total = res.data.data.total;
      list.value = res.data.data.records;
    } else {
      ElMessage.error(res.data.message);
    }
  });
};
getList();
const currentChange = function (val) {
  console.log(val);
  from1.value.pageIndex = val;
  getList();
};
const prevClick = function (val) {
  console.log(val);
  from1.value.pageIndex = val;
  getList();
};
const nextClick = function (val) {
  from1.value.pageIndex = val;
  getList();
};
</script>

<style scoped lang="less">
.body {
  width: 12.8rem;
  margin: 0 auto;
  margin-top: 0.8rem;
  margin-bottom: 0.2rem;
}

.bodySelect .select:hover {
  .select_box {
    display: block;
  }
}

.bodySelect {
  display: flex;
  border-radius: 0.1rem;
  overflow: hidden;

  .select_icon {
    margin-left: 0.04rem;
    width: 0.14rem;
    height: 0.14rem;
    margin-top: 0.04rem;
    background: url(data:image/png;base64,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);
    background-size: 100% 100%;
  }

  .select_box {
    position: absolute;
    // margin-top: 0.18rem;
    text-align: center;
    min-width: 0.8rem;
    z-index: 15;
    border-radius: 0.08rem;
    background: #fff;
    padding: 0.04rem;
    box-sizing: border-box;
    display: none;
    box-shadow: 0rem 0.04rem 0.12rem 0rem rgba(32, 40, 58, 0.25);

    .select_box_slect:hover,
    .selectboxTrue {
      background: #f0f1f1;
      color: #333333;
      cursor: pointer;
    }

    .select_box_slect {
      line-height: 0.37rem;
      padding: 0 0.08rem !important;
      box-sizing: border-box;
    }
  }
}

.bodySelect_flex {
  display: flex;
  align-items: center;
  flex-grow: 1;
  background: #f2f3f5;
}

.bodySelect_flex>input {
  flex-grow: 1;
  padding: 0 0.12rem;
  border: 0rem solid #fff;
  font-size: 0.14rem;
  // border-left: 0.01rem solid #86909c;
  background: #f2f3f5;
}

.bodySelect>button {
  background: #c01a26;
  color: #ffffff;
  font-size: 0.14rem;
  padding: 0.16rem 0.24rem;
  border: 0rem solid #fff;
  align-items: center;
}

.bodySelect>button>img {
  width: 0.16rem;
  margin-right: 0.04rem;
}

/deep/.el-input__wrapper,
.el-input,
.el-input--suffix {
  width: 0.74rem;
  background: #f2f3f5;
}

/deep/ .el-input,
.el-input--suffix {
  border: 0rem solid #fff;
}

/deep/.el-pager li {
  padding: 0.06rem;
  margin: 0 0.03rem;
}

/deep/.el-pager li.is-active {
  color: #fff;
  background: #c01a26;
}

/deep/.el-pager li:hover {
  color: #fff;
  background: #c01a26;
}

.el-pagination {
  justify-content: center;
  margin: 0.4rem 0;
}

.menu-left {
  justify-content: flex-start;
}
</style>
